<template>
  <section class="place">
    <h1>{{ textData[lang.key].place.title }}</h1>
    <p>{{ textData[lang.key].place.text }}</p>
    <div
      :style="{ 'background-image': 'url(' + backgroundImageSrc + ')' }"
      class="place__prefectures">
      <button
        class="place__prefectures_btn-location"
        @click="placeSearch(2)">
        <i class="icon-location"/>
        {{ textData[lang.key].place.btn1 }}
      </button>
      <button
        :class="{ 'place__prefectures_btn-all--none': museumList.length === 0 }"
        class="place__prefectures_btn-all"
        @click="placeSearch(0)">
        {{ textData[lang.key].place.btn2 }}
        <div
          :class="{ 'place__prefectures_btn-all_num--none': museumList.length === 0 }"
          class="place__prefectures_btn-all_num">
          {{ museumList.length }}
        </div>
      </button>
      <svg
        viewBox="0 0 335 249">
        <g
          v-for="(name, index) in positionAry"
          :key="'positionAry' + index">
          <rect
            :width="calcRectWidth('text' + (index + 2))"
            :height="calcRectHeight('text' + (index + 2))"
            :x="btnPosition[name + 'X'][lang.params]"
            :y="btnPosition[name + 'Y'][lang.params]"
            :stroke="Array.isArray(defaultFormatList[index + 1]) && defaultFormatList[index + 1].length > 0 ? '#ffffff' : '#999999'"
            @click="placeSearch('1' + String(index + 1))"/>
          <circle
            :cx="btnPosition[name + 'X'][lang.params] + calcRectWidth('text' + (index + 2))"
            :cy="btnPosition[name + 'Y'][lang.params]"
            :fill="Array.isArray(defaultFormatList[index + 1]) && defaultFormatList[index + 1].length > 0 ? '#ffffff' : '#999999'"
            r="7"
            stroke="none"/>
          <text
            :x="btnPosition[name + 'X'][lang.params] + calcRectWidth('text' + (index + 2))"
            :y="btnPosition[name + 'Y'][lang.params] - 1"
            text-anchor = "middle"
            dominant-baseline = "central"
            class="text-num">
            {{ Array.isArray(defaultFormatList[index + 1]) ? defaultFormatList[index + 1].length : 0 }}
          </text>
          <text
            :ref="'text' + (index + 2)"
            :x="btnPosition[name + 'X'][lang.params] + (rectPadding.x / 2)"
            :y="btnPosition[name + 'Y'][lang.params] + calcRectHeight('text' + (index + 2)) - (mediaType === 'pc' ? 6 : 3)"
            :fill="Array.isArray(defaultFormatList[index + 1]) && defaultFormatList[index + 1].length > 0 ? '#ffffff' : '#999999'"
            class="text-name"
            @click="placeSearch('1' + String(index + 1))">
            {{ textData[lang.key].place['region' + (index + 1)] }}
          </text>
        </g>
      </svg>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import setting from '@/setting.js'

export default {
  name: 'Place',
  components: {
    setting,
    mapGetters
  },
  computed: {
    ...mapGetters(['textData', 'lang', 'museumList', 'searchMode', 'mediaType']),
    backgroundImageSrc: function () {
      return require('@/assets/img/img-area.png')
    },
    svgWidth: function () {
      let width = ''
      if (window.innerWidth >= 479) {
        width = 676
      } else {
        width = window.innerWidth - 40
      }
      return width
    },
    svgHeight: function () {
      let height = ''
      if (window.innerWidth >= 479) {
        height = 513
      } else {
        height = (window.innerHeight / 264) * 100
      }
      return height
    },
    calcRectWidth: function () {
      return function () {
        let elemNum = arguments[0]
        let width = 0
        if (elemNum in this.$refs) {
          let bbox = this.$refs[elemNum][0].getBBox()
          width = bbox.width + this.rectPadding.x
        }
        return width
      }
    },
    calcRectHeight: function () {
      return function () {
        let elemNum = arguments[0]
        let height = 0
        if (elemNum in this.$refs) {
          let bbox = this.$refs[elemNum][0].getBBox()
          height = bbox.height + this.rectPadding.y
          if (window.innerWidth >= 479) {
            height = height + 11
          }
        }
        return height
      }
    },
    // 通常時のリスト
    defaultFormatList: function () {
      let tmpObj = {}
      this.museumList.forEach(list => {
        if (!tmpObj[setting.prefecturesList[list.museum_pref]]) {
          tmpObj[setting.prefecturesList[list.museum_pref]] = []
        }
        tmpObj[setting.prefecturesList[list.museum_pref]].push(list)
      })
      console.log('tmpObj:', tmpObj)
      return tmpObj
    }
  },
  data () {
    return {
      setting,
      rectPadding: {
        x: 12,
        y: 8
      },
      positionAry: [
        'hokkaido',
        'tohoku',
        'kanto',
        'chubu',
        'kinki',
        'chugokuShikoku',
        'kyushuOkinawa'
      ],
      btnPosition: {
        hokkaidoX: {
          'ja': 238,
          'en': 238,
          'zh-CN': 238,
          'zh-TW': 238,
          'ko': 238,
          'ru': 238,
          'fr': 238,
          'de': 238,
          'es': 238,
          'pt': 238,
          'it': 238,
          'th': 238
        },
        hokkaidoY: {
          'ja': 32,
          'en': 32,
          'zh-CN': 32,
          'zh-TW': 32,
          'ko': 32,
          'ru': 32,
          'fr': 32,
          'de': 32,
          'es': 32,
          'pt': 32,
          'it': 32,
          'th': 32
        },
        tohokuX: {
          'ja': 202,
          'en': 202,
          'zh-CN': 202,
          'zh-TW': 202,
          'ko': 202,
          'ru': 202,
          'fr': 177,
          'de': 202,
          'es': 177,
          'pt': 177,
          'it': 177,
          'th': 202
        },
        tohokuY: {
          'ja': 100,
          'en': 100,
          'zh-CN': 100,
          'zh-TW': 100,
          'ko': 100,
          'ru': 100,
          'fr': 100,
          'de': 100,
          'es': 100,
          'pt': 100,
          'it': 100,
          'th': 100
        },
        kantoX: {
          'ja': 190,
          'en': 202,
          'zh-CN': 190,
          'zh-TW': 190,
          'ko': 190,
          'ru': 202,
          'fr': 202,
          'de': 202,
          'es': 202,
          'pt': 202,
          'it': 188,
          'th': 190
        },
        kantoY: {
          'ja': 175,
          'en': 164,
          'zh-CN': 175,
          'zh-TW': 175,
          'ko': 175,
          'ru': 164,
          'fr': 164,
          'de': 164,
          'es': 164,
          'pt': 164,
          'it': 164,
          'th': 175
        },
        chubuX: {
          'ja': 140,
          'en': 103,
          'zh-CN': 140,
          'zh-TW': 140,
          'ko': 140,
          'ru': 140,
          'fr': 103,
          'de': 103,
          'es': 103,
          'pt': 103,
          'it': 103,
          'th': 140
        },
        chubuY: {
          'ja': 145,
          'en': 131,
          'zh-CN': 145,
          'zh-TW': 145,
          'ko': 145,
          'ru': 145,
          'fr': 131,
          'de': 131,
          'es': 131,
          'pt': 131,
          'it': 131,
          'th': 145
        },
        kinkiX: {
          'ja': 115,
          'en': 140,
          'zh-CN': 115,
          'zh-TW': 115,
          'ko': 125,
          'ru': 125,
          'fr': 140,
          'de': 140,
          'es': 140,
          'pt': 140,
          'it': 140,
          'th': 115
        },
        kinkiY: {
          'ja': 191,
          'en': 207,
          'zh-CN': 191,
          'zh-TW': 191,
          'ko': 191,
          'ru': 191,
          'fr': 207,
          'de': 207,
          'es': 207,
          'pt': 207,
          'it': 207,
          'th': 191
        },
        chugokuShikokuX: {
          'ja': 6,
          'en': 3,
          'zh-CN': 6,
          'zh-TW': 6,
          'ko': 3,
          'ru': 3,
          'fr': 3,
          'de': 3,
          'es': 3,
          'pt': 3,
          'it': 3,
          'th': 3
        },
        chugokuShikokuY: {
          'ja': 172,
          'en': 172,
          'zh-CN': 172,
          'zh-TW': 172,
          'ko': 172,
          'ru': 172,
          'fr': 172,
          'de': 172,
          'es': 172,
          'pt': 172,
          'it': 172,
          'th': 172
        },
        kyushuOkinawaX: {
          'ja': 0,
          'en': 0,
          'zh-CN': 0,
          'zh-TW': 0,
          'ko': 0,
          'ru': 0,
          'fr': 0,
          'de': 0,
          'es': 0,
          'pt': 0,
          'it': 0,
          'th': 0
        },
        kyushuOkinawaY: {
          'ja': 215,
          'en': 215,
          'zh-CN': 215,
          'zh-TW': 215,
          'ko': 215,
          'ru': 215,
          'fr': 215,
          'de': 215,
          'es': 215,
          'pt': 215,
          'it': 215,
          'th': 215
        }
      }
    }
  },
  methods: {
    placeSearch: function (m) {
      // 0:デフォルト 1x:地域選択 2:位置情報
      const mode = Number(m)
      console.log('placeSearch:', mode)
      if (mode === 0) {
        // 施設リストが1件以上ある場合はmodalを表示
        if (this.museumList.length > 0) {
          this.$store.dispatch('setSliderFlg', mode)
        }
      } else if (mode >= 10) {
        let prefNum = Number(m.slice(1, 2))
        // 地域別の施設リストが1件以上ある場合はmodalを表示
        if (Array.isArray(this.defaultFormatList[prefNum]) && this.defaultFormatList[prefNum].length > 0) {
          this.$store.dispatch('setSliderFlg', mode)
        }
      } else if (mode === 2) {
        this.$store.dispatch('setSliderFlg', mode)
      } else {
        this.$store.dispatch('setSliderFlg', mode)
      }
    }
  },
  mounted () {
  },
  created () {
    if (window.innerWidth >= 479) {
      this.rectPadding.y = -5
    }
  },
  beforeUpdate () {
  },
  updated () {
  },
  activated () {
  },
  watch: {
    'lang': function () {
      // 地域選択のsvgを更新するため
      window.setTimeout(() => {
        this.$forceUpdate()
      }, 1)
    }
  }
}
</script>
<style lang="postcss" scoped>
  @import '../../assets/css/mixins.css';
  @import '../../assets/css/variables.css';

  .place {
    color: #FFFFFF;
    background: #2E2E2E;
    padding-bottom: 70px;
    & h1 {
      color: #FFFFFF;
      font-size: 40px;
      text-align: center;
      padding: 70px 0;
    }
    & p {
      font-size: 20px;
      line-height: 27px;
      text-align: center;
      white-space: pre-wrap;
    }
    &__prefectures {
      position: relative;
      width: 676px;
      /* max-width: 890px; */
      height: 513px;
      margin: 50px auto 0;
      background: no-repeat center;
      background-size: contain;
      & button {
        position: absolute;
        left: 0;
        width: 260px;
        height: 45px;
        font-size: 16px;
        line-height: 18px;
        cursor: pointer;
      }
      &_btn-location {
        top: 0;
        background: #CC3454;
        padding: 1px 5px;
        color: #FFFFFF;
        & .icon-location {
          display: inline-block;
          width: 18px;
          height: 18px;
          margin: 0 5px 0 0;
          background: url('~@/assets/img/icon-location.png');
          background-size: 18px;
          vertical-align: sub;
        }
      }
      &_btn-all {
        top: 70px;
        background: rgba(0,0,0,0.45);
        border: 1px #FFFFFF solid;
        color: #FFFFFF;
        &--none {
          color: #999999;
          border: 1px #999999 solid;
        }
        &_num {
          position: absolute;
          top: -14px;
          right: -14px;
          background: #ffffff;
          width: 28px;
          height: 28px;
          border-radius: 50%;
          color: #000000;
          line-height: 28px;
          &--none {
            background: #999999;
          }
        }
      }
      svg {
        width: 676px;
        height: 513px;
        & g {
          cursor: pointer;
        }
      }
      rect {
        fill: #000000;
        fill-opacity: 0.45;
        /* stroke: #ffffff; */
      }
      text.text-num {
        fill: #000000;
        font-size: 8px;
      }
      text.text-name {
        transform: translateY(1.5px);
        font-size: 10px;
      }
    }
  }
  @media (--breakPoint) {
    .place {
      padding: 0 20px 40px;
      & h1 {
        font-size: 28px;
        padding: 40px 0;
      }
      & p {
        font-size: 14px;
        line-height: 26px;
      }
      &__prefectures {
        width: 100%;
        max-width: 500px;
        height: calc((100% / 264) * 100);
        margin: 40px auto 0;
        & button {
          position: absolute;
          left: 0;
          width: 165px;
          height: 26px;
          font-size: 10px;
          line-height: 11px;
          cursor: pointer;
        }
        &_btn-location {
          top: 0;
          padding: 1px 5px;
          & .icon-location {
            width: 12px;
            height: 12px;
            margin: 0 5px 1px 0;
            background-size: 12px;
          }
        }
        &_btn-all {
          top:50px;
          background: rgba(0,0,0,0.45);
          border: 1px #FFFFFF solid;
          &--none {
            color: #999999;
            border: 1px #999999 solid;
          }
          &_num {
            position: absolute;
            top: -14px;
            right: -14px;
            background: #ffffff;
            width: 28px;
            height: 28px;
            border-radius: 50%;
            &--none {
              background: #999999;
            }
          }
        }
        svg {
          width: 100%;
          height: 100%;
        }
        rect {
        }
        text.text-num {
          fill: #000000;
          font-size: 8px;
        }
        text.text-name {
          font-size: 10px;
          transform: translateY(-3px);
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/templates/Place.vue